var $ = jQuery;

$.fn.openEssay = function(nid, html) {
  // Empty out all essays and show all constitution text
  $('.con-essay-wrapper').empty();
  $('.con-constitution').removeClass('hidden');

  $('.con-essay-container').hide();
  $('.selectric-item-list a').removeClass('active');
  $('.con-essay-block').removeClass('open');

  $('.selectric-item-list a[data-href$="essay_controller/' + nid + '"]').addClass('active');
  $('a[data-href$="essay_controller/' + nid + '"]').each(function() {
    const $link = $(this);
    let $article = $link.closest('article.node--type-constitution-guide');
    if (!$article.length) {
      $article = $('article.node--type-constitution-guide').first();
    }
    $('.con-essay-wrapper', $article).html(html);
    $('.con-essay-container', $article).show();
    $('.con-essay-block', $article).addClass('open');

    $article.trigger('openEssay');
    Drupal.attachBehaviors($('.con-essay-wrapper', $article).get(0));
  });
};

Drupal.behaviors.constitutionEssayTabs = {
  attach: function(context) {
    if (!$('.con-essay-tabs', context).length || typeof window.Tabby === 'undefined') {
      return;
    }
    new Tabby('.con-essay-tabs [data-tabs]');
  }
};

function handleLinksAndPaths() {
  const $essayLinks = $('a[data-href]');

  // Make clicking the essays trigger the ajax call.
  $essayLinks.each(function(i, ajaxLink) {
    var $linkElement = $(ajaxLink);
    var elementSettings = {
      base: $linkElement.attr('id'),
      element: ajaxLink
    };
    var href = $linkElement.attr('data-href');
    if (href) {
      elementSettings.url = href;
      elementSettings.event = 'click';
    }
    Drupal.ajax(elementSettings);
  });
  
  // Change url on essay click.
  $essayLinks.on('click', function() {
    const path = $(this).attr('href');
    sendPageView(path);
    const newPath = path.replace("/constitution/", "/constitution/#!/")
    window.history.pushState({}, '', newPath);
  })
  
  // Correct path from e.g. /constitution#!/x to /constitution/#!/x
  let hash = window.location.hash;
  let path = window.location.pathname;
  if (hash) {
    const newPath = path + "/" + hash;
    window.history.pushState({}, '', newPath);
  }
  
  // Load essay via url.
  if (hash) {
    const prettyPath = path + "/" + hash.replace("#!/", "");
    $(`a[href="${prettyPath}"]`).first().trigger('click');
  }
}

function handleTooltips() {
  const $constitutionContainer = $('.constitution-container');

  $('.con-body a[data-href]').each(function() {
    const $link = $(this);
    if ($link.find('.tooltip__handler').length) {
      return;
    }
    const $handler = $('<span class="tooltip__handler"></span>');
    $link.append($handler);
  });

  if (typeof $.fn.tooltip === 'function'
   && typeof drupalSettings.constitutionEssaysTooltip === 'object') {
    $constitutionContainer.tooltip({
      items: '.con-body a[data-href^="/essay_controller/"]',
      content: function() {
        const $link = $(this);
        const target = $link.attr('data-href');
        const pos = target.indexOf('essay_controller/');
        if (pos === -1) {
          return;
        }
        const id = target.substr(pos+17).trim();
        if (typeof drupalSettings.constitutionEssaysTooltip[id] === 'undefined') {
          return;
        }
        let output = '';
        let subheading = [];
        let essayData = drupalSettings.constitutionEssaysTooltip[id];
        if (essayData.title) {
          output += '<div class="constitution-tooltip__title">' + essayData.title + '</div>';
        }
        if (essayData.article) {
          subheading.push(essayData.article);
        }
        if (essayData.section && essayData.section !== 'NULL') {
          subheading.push('Section ' + essayData.section);
        }
        if (subheading.length) {
          output += '<div class="constitution-tooltip__subheading">- ' + subheading.join(', ') + '</div>';
        }
        if (!output) {
          return;
        }

        return output;
      },
      classes: {
        "ui-tooltip": "constitution-tooltip"
      },
      position: {
        at: "left bottom",
        collision: "flipfit",
        using: function(position, feedback) {
          if (feedback.target && feedback.target.element) {
            const $tooltip = $(this);
            const $link = $(feedback.target.element);
            const $handler = $link.find('.tooltip__handler');
            if ($handler.length) {
              position = $handler.offset();
              position.left -= ($tooltip.width() * .5) + 5;
              position.top += 38;
            }
          }
          $(this).css(position);
        }
      }
    });
  }
}

function handleGuides() {
  $('.node--type-constitution-guide').each(function() {
    const $node = $(this);

    const constMenuBtn = $('#selectric-const-menu-btn', $node);
    const constSliderContainer = $('.con-sidebar', $node);
    const constSideBar = $('.selectric-item-list', $node);
    const constSideBarItem = $('.selectric-item-list a', $node);
    const constEssayContainer = $('#con-essay-container', $node);
    const constBodyContainer = $('.con-constitution', $node);

    //side menu dropdown
    constMenuBtn.on("click", function () {
      constSideBar.slideToggle(300);
      constSliderContainer.toggleClass('open');
    });

    // Collapse sidebar on mobile.
    if ($(window).width() < 700) {
      constSideBar.slideToggle(0);
      constSliderContainer.toggleClass('open');
    }

    function closeEssay() {
      const $container = $('.con-essay-container', $node);
      $container.find('.con-essay-wrapper').empty();
      const container = $container.get(0);
      if (container !== null) {
        container.classList.remove('open');
        constBodyContainer.removeClass('hidden');
        constSideBarItem.removeClass('active');
        constEssayContainer.addClass('hidden');
        constEssayContainer.removeAttr('style');
        // Reset url.
        window.history.pushState({}, '', window.location.pathname);
      }
    }
    function openEssay() {
      constEssayContainer.addClass('open');
      constBodyContainer.addClass('hidden');
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".con-essay-wrapper", $node).offset().top
      }, 500);
    }
    const $closeButton = $('.con-essay-close', $node);
    if ($closeButton.length) {
      $closeButton.on('click', closeEssay);
    }
    $node.on('closeEssay', closeEssay);
    $node.on('openEssay', openEssay);
  });
}

function handleSidebar() {
  const $constitutionContainer = $('.constitution-container');
  let sidebar;
  if ($constitutionContainer.length && typeof window.StickySidebar !== 'undefined') {
    sidebar = new window.StickySidebar('.discussion-menu__wrapper', {
      containerSelector: '.constitution-container',
      innerWrapperSelector: '.discussion-main-menu',
      minWidth: 768
    });
  }
}

function handleTabs() {
  document.addEventListener('tabby', function (event) {
    let $tab = $(event.target);
    $('.con-essay-tabs .button-more').toggleClass('active', false);
    $tab.closest('.button-more').toggleClass('active', true);
  }, false);
}

function handleGuideLinks() {
  $('.view-constitution-page .discussion-main-menu a').on('click', function(e) {
    e.preventDefault();
    const path = $(this).attr('href');
    sendPageView(path);
    const newPath = path.replace("/constitution/", "/constitution/#!/");
    window.history.pushState({}, '', newPath);
    const args = path.split('/');
    let section = args[args.length - 1];
    $("html").scrollTop($(`#${section}`).offset().top);
  });
}

function handleAmendmentLinks() {
  $('ul.amendments a').on('click', function(e) {
    e.preventDefault();
    const path = $(this).attr('href');
    sendPageView(path);
    const newPath = path.replace("/constitution/", "/constitution/#!/");
    window.history.pushState({}, '', newPath);
    const args = path.split('/');
    const amendmentNumber = args[3];
    const section = 'amendments' + amendmentNumber;
    $("html").scrollTop($(`#${section}`).offset().top);
  })
}

function handleRedirects() {
  let path = window.location.pathname;
  if (path.substr(0,14) === "/constitution/") {
    let redirectPath = path.replace("/constitution/", "/constitution/#!/");
    window.location.replace(redirectPath);
  }
}

function sendPageView(path) {
  const args = path.split('/');
  let title = args[args.length - 1];
  title = title.replace(/-/g, " ");
  title = title.replace(/^(.)|\s(.)/g, function($1){ return $1.toUpperCase( ); })
  title = title + ' | The Heritage Guide to the Constitution';
  dataLayer.push({
    event: 'pageview',
    page: {
      path,
      title
    }
  });
}

function init() {
  handleRedirects();
  handleGuideLinks();
  handleAmendmentLinks();
  handleLinksAndPaths();
  handleSidebar();
  handleTooltips();
  handleGuides();
  handleTabs();
}

export { init as init };
